import type { JSX, ReactNode } from 'react';

export interface ITooltip {
	children?: ReactNode;
	tipElement?: JSX.Element;
}

export const normalizePlacement = (placement?: string) => {
	if (!placement) return '';
	if (placement.startsWith('top')) return ' top';
	if (placement.startsWith('bottom')) return ' bottom';
	if (placement.startsWith('left')) return ' left';
	if (placement.startsWith('right')) return ' right';
	return '';
};

export interface ITooltipContent {
	content: string;
	linkTitle?: string;
	linkUrl?: string;
	onLinkClick?: () => void;
	loading?: boolean;
}
